import { useMutation, useQuery } from "react-query";
import { getCategories } from "../../utils/api/categories/getCategories";
import { useSnackbar } from "notistack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import styles from "./categories.module.css";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { useEffect, useRef, useState } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { DialogActions, IconButton, Paper, TextField, Tooltip } from "@mui/material";
import { DeleteOutline, EditOutlined, ListOutlined, UploadFileOutlined, UploadOutlined } from "@mui/icons-material";
import { createCategory } from "../../utils/api/categories/createCategory";
import { updateCategory } from "../../utils/api/categories/updateCategory";
import { destroyCategory } from "../../utils/api/categories/destroyCategory";
import { Controller, useForm } from "react-hook-form";
import categoryPhoto from "../../styles/images/photo-placeholder.jpg";
import categoryThumbnail from "../../styles/images/thumbnail-placeholder.png";
import { useFileUploadMutation } from "../../utils/api/categories/useFileUploadMutation";
import { useNavigate } from "react-router";

const PHOTOS_ENDPOINT = process.env.REACT_APP_PHOTOS_ENDPOINT;

const Categories = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const photoInputRef = useRef(null);
  const [dialog, setDialog] = useState(null);
  const [destroyDialog, setDestroyDialog] = useState(null);
  const [uploadType, setUploadType] = useState(null);
  const navigate = useNavigate();

  const handleDialogClose = () => setDialog(null);
  const handleDestroyDialogClose = () => setDestroyDialog(null);

  const handleDialogOpen = (data) => {
    setValue("title", data.title);
    setValue("description", data.description);
    setDialog(data);
  };

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const onCreateSubmit = (data) => createCategoryMutation.mutate(data);
  const onUpdateSubmit = (data) => updateCategoryMutation.mutate({ id: dialog.id, ...data });

  const {
    mutation: uploadFileMutation,
    progress: uploadFileProgress,
    result: uploadFileResult,
  } = useFileUploadMutation();

  useEffect(() => {
    getCategoriesQuery.refetch();
    closeSnackbar();
  }, [uploadFileResult]);

  const handleUploadPhoto = (e) => {
    uploadFileMutation.mutate({
      id: uploadType.id,
      file: e.target.files[0],
      rowId: uploadType.id,
      fileType: uploadType.type,
      rowType: "category",
    });
    enqueueSnackbar("در حال آپلود" + uploadFileProgress, {
      persist: true,
    });
  };

  const getCategoriesQuery = useQuery("get-categories", () => getCategories(), {
    onSuccess: (data) => {},
    onError: (error) => {
      enqueueSnackbar("خطا در دریافت دسته بندی ها", { variant: "error" });
    },
  });

  const createCategoryMutation = useMutation("create-category-mutation", (data) => createCategory(data), {
    onSuccess: (data) => {
      enqueueSnackbar("دسته بندی با موفقیت ایجاد شد", { variant: "success" });
      handleDialogClose();
      getCategoriesQuery.refetch();
    },
    onError: (error) => {
      enqueueSnackbar("خطا در ایجاد دسته بندی", { variant: "error" });
    },
  });

  const updateCategoryMutation = useMutation("update-category-mutation", (data) => updateCategory(data), {
    onSuccess: (data) => {
      enqueueSnackbar("دسته بندی با موفقیت ویرایش شد", { variant: "success" });
      handleDialogClose();
      getCategoriesQuery.refetch();
    },
    onError: (error) => {
      enqueueSnackbar("خطا در ویرایش دسته بندی", { variant: "error" });
    },
  });

  const destroyCategoryMutation = useMutation("destroy-category-mutation", (data) => destroyCategory(data), {
    onSuccess: (data) => {
      enqueueSnackbar("دسته بندی با موفقیت حذف شد", { variant: "success" });
      handleDestroyDialogClose();
      getCategoriesQuery.refetch();
    },
    onError: (error) => {
      enqueueSnackbar("خطا در حذف دسته بندی", { variant: "error" });
    },
  });

  return (
    <>
      <Grid container>
        <Grid item size={12}>
          <Grid container direction={"row"} flexWrap={"nowrap"} alignItems={"center"} justifyContent={"center"}>
            <Typography>دسته بندی‌ها</Typography>
            <div className={styles["fg-1"]} />
            <Button
              variant='contained'
              color='primary'
              onClick={() =>
                handleDialogOpen({
                  type: "create",
                  id: null,
                  title: "",
                  description: "",
                })
              }
            >
              افزودن دسته بندی
            </Button>
          </Grid>
        </Grid>

        <Grid item size={12}>
          <Grid container marginTop={2} alignItems={"flex-start"} justifyContent={"flex-start"} spacing={2}>
            {getCategoriesQuery?.isLoading ? (
              <Typography>در حال بارگذاری...</Typography>
            ) : getCategoriesQuery?.isError ? (
              <Typography>خطا در بارگذاری دسته بندی ها</Typography>
            ) : getCategoriesQuery?.data?.data?.categories?.length === 0 ? (
              <Typography>دسته بندی وجود ندارد</Typography>
            ) : (
              getCategoriesQuery?.data?.data?.categories?.map((category) => (
                <Grid item key={category.id} size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper className={styles["category-paper"]}>
                    <Grid container alignItems={"flex-start"} alignContent={"center"} direction={"column"} spacing={1}>
                      <Grid item size={12} direction={"column"} position={"relative"}>
                        <img
                          src={category.photo_url ? `${PHOTOS_ENDPOINT}/${category.photo_url}` : categoryPhoto}
                          alt={category.title}
                          className={styles["category-photo"]}
                        />
                        <Typography variant='caption'>نسبت تصویر پیشنهادی: ۹:۱۴</Typography>
                        {/* <img
                          src={
                            category.thumbnail_url ? `${PHOTOS_ENDPOINT}/${category.thumbnail_url}` : categoryThumbnail
                          }
                          alt={category.title}
                          className={styles["category-thumbnail"]}
                        /> */}
                        <Typography variant='h6' style={{ marginTop: 10 }}>
                          {category.title}
                        </Typography>
                        <Typography variant='body2'>{category.description}</Typography>
                      </Grid>
                      <Grid item size={12}>
                        <Grid container direction={"row"} spacing={1}>
                          <Tooltip title='آیتم‌ها' arrow>
                            <IconButton
                              size='medium'
                              color='secondary'
                              onClick={() => navigate(`/panel/category/${category.id}`)}
                            >
                              <ListOutlined />
                            </IconButton>
                          </Tooltip>
                          <Tooltip
                            title='ویرایش دسته بندی'
                            arrow
                            onClick={() =>
                              handleDialogOpen({
                                type: "update",
                                id: category.id,
                                title: category.title,
                                description: category.description,
                              })
                            }
                          >
                            <IconButton size='medium' color='secondary'>
                              <EditOutlined />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title='حذف دسته بندی' arrow onClick={() => setDestroyDialog({ id: category.id })}>
                            <IconButton size='medium' color='secondary'>
                              <DeleteOutline />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title='آپلود تصویر دسته بندی' arrow>
                            <IconButton
                              size='medium'
                              color='secondary'
                              onClick={() => {
                                photoInputRef.current.value = null;
                                photoInputRef.current.click();
                                setUploadType({ id: category.id, type: "photo" });
                              }}
                              disabled={uploadFileMutation.isLoading}
                            >
                              <UploadFileOutlined />
                            </IconButton>
                          </Tooltip>
                          {/* <Tooltip title='آپلود آیکون دسته بندی' arrow>
                            <IconButton
                              size='medium'
                              color='secondary'
                              onClick={() => {
                                photoInputRef.current.value = null;
                                photoInputRef.current.click();
                                setUploadType({ id: category.id, type: "thumbnail" });
                              }}
                            >
                              <UploadOutlined />
                            </IconButton>
                          </Tooltip> */}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              ))
            )}
          </Grid>
        </Grid>
      </Grid>

      <input
        type='file'
        id='photo_upload'
        accept='image/*'
        onChange={handleUploadPhoto}
        ref={photoInputRef}
        style={{ display: "none" }}
      />

      <Dialog open={destroyDialog} onClose={handleDestroyDialogClose}>
        <DialogTitle>حذف دسته بندی</DialogTitle>
        <DialogContent>
          <DialogContentText>
            در صورت حذف دسته بندی تمامی ایتم های زیر مجموعه این دسته بندی نیز حذف میگردد! این عملیات غیر قابل بازگشت
            است.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDestroyDialogClose}>لغو</Button>

          <Button
            variant='contained'
            color='error'
            onClick={() => destroyCategoryMutation.mutate({ id: destroyDialog?.id })}
            loading={destroyCategoryMutation.isLoading}
            disabled={destroyCategoryMutation.isLoading}
          >
            حذف دسته بندی
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dialog} onClose={handleDialogClose}>
        <DialogTitle>{dialog?.type === "update" ? "ویرایش" : "ایجاد"} دسته بندی </DialogTitle>
        <DialogContent>
          {/* <DialogContentText>ایجاد دسته بندی</DialogContentText> */}
          <form onSubmit={handleSubmit(dialog?.type === "update" ? onUpdateSubmit : onCreateSubmit)}>
            <Controller
              name='title'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.title}
                  helperText={errors.title && "نام دسته بندی الزامی است."}
                  className={styles.textFields}
                  disabled={createCategoryMutation.isLoading || updateCategoryMutation?.isLoading}
                  variant='outlined'
                  label='نام دسته بندی'
                  margin='dense'
                  fullWidth
                />
              )}
            />

            <Controller
              name='description'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.description}
                  helperText={errors.description && "توضیحات الزامی است."}
                  className={styles.textFields}
                  disabled={createCategoryMutation.isLoading || updateCategoryMutation?.isLoading}
                  variant='outlined'
                  label='توضیحات'
                  margin='dense'
                  fullWidth
                />
              )}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>لغو</Button>

          <Button
            variant='contained'
            onClick={handleSubmit(dialog?.type === "update" ? onUpdateSubmit : onCreateSubmit)}
            loading={createCategoryMutation.isLoading || updateCategoryMutation?.isLoading}
            disabled={createCategoryMutation.isLoading || updateCategoryMutation?.isLoading}
          >
            {dialog?.type === "update" ? "ویرایش" : "ایجاد"} دسته بندی
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Categories;
